<template>
  <div class="row Order">
    <div class="col">
      <div class="Title">
        <span>訂單明細</span>
        <span class="discountPrice" v-if="this.$parent.$data.discountPrice != null">${{this.$parent.$data.discountPrice}}</span>
        <span class="Total" :class="{'replaced': this.$parent.$data.discountPrice != null}">${{Total}}</span>
      </div>
      <div class="orderList" v-for="(List, Ui) in Cart" :key="(List.id, Ui)">
        <div class="User" v-if="Ui > 0">
          <span class="Name">{{List.User.userName}}</span>
          <span class="Delete">
            <span @click="deleteOrderUser(Ui)"><i class="Delete fa-solid fa-trash-can fa-2x"></i></span>
          </span>
        </div>
        <div class="Product" :class="{ 'IndentProduct': Ui > 0 }" v-for="(Product, Pi) in List.Data" :key="(Product.id, Pi)">
          <div class="Image" v-if="Product.Image"><img :src="Global.Domain + Product.Image"></div>
          <div class="Fas" v-else><i class="fas fa-utensils fa-3x" /></div>
          <div class="Name" :class="{'noProduct': this.$parent.$data.GrayOrder[Ui][Pi]}">
            {{Product.Name}}
            <span class="editOrderBar" v-if="Ui == 0">
              <span @click="deleteOrderProduct(Ui, Pi)"><i class="Delete fa-solid fa-trash-can fa-2x"></i></span>
            </span>
          </div>
          <div class="Content">
            <span v-if="Product.Items">
              <span v-for="(Item) in Product.Items" :key="Item">{{Item.Name}}<span> / </span></span>
            </span>
            <span>${{Product.Price}} / {{Product.Count}}份</span>
          </div>
        </div>
      </div>
      <div class="activityBar" v-if="activityContent">{{activityContent}}</div>
    </div>
  </div>
</template>

<script>
import { Global } from '@/Service/GlobalService'
export default {
  name: "Order",
  props: {
    Cart: Array,            // 購物車商品列表
    Total: Number,          // 購物車金額
    activityContent: String // 促銷敘述
  },
  data() {
    return {
      Global: Global,
      Shop: Global.Shop,
    }
  },
  watch: { 
    /* 判斷Total是否有變動 */
    Total: function() {
      /* 判斷店家促銷是否有開啟，有的話設置促銷訊息跟折扣價格 */
      if (this.checkActivity()) this.setActivityContent()
    }
  },
  methods: {
    /* 刪除購物車指定商品 */
    deleteOrderProduct: function(Ui, Pi) {
      if (this.$parent.$data.horderHandler == 0) return false
      this.$parent.$data.Cart[Ui].Data.splice(Pi, 1)
      this.$parent.$data.GrayOrder[Ui].splice(Pi, 1)
      Global.Cart = this.$parent.$data.Cart
      localStorage.setItem('Cart.' + Global.Shop.id, JSON.stringify(this.$parent.$data.Cart[0].Data))
    },
    /* 刪除購物車指定團購參與者 */
    deleteOrderUser: function(index) {
      if (this.$parent.$data.horderHandler == 0) return false
      this.$parent.$data.Cart.splice(index, 1)
      Global.Cart = this.$parent.$data.Cart
      Global.Groupbuy[this.$route.query.Token].splice(index - 1, 1)
    },
    /* 檢查促銷是否進行 */
    checkActivity: function() {
      let Flag = false
      if (this.$data.Shop.Activity == "開") {
        if (this.$moment(new Date()).format('HH:mm') < this.$moment(this.$data.Shop.timeBefore, "HH:mm").format('HH:mm')) {
          Flag = true
        } else if (this.$moment(new Date()).format('HH:mm') > this.$moment(this.$data.Shop.timeAfter, "HH:mm").format('HH:mm')) {
          Flag = true
        }
      }
      return Flag
    },
    /* 設置促銷訊息 */
    setActivityContent: function() {
      if (this.$props.Total < this.$data.Shop.activityPrice) {
        this.$parent.$data.discountPrice = null
        return false
      }
      let activityContent = "在 "
      if (this.$data.Shop.timeBefore && this.$data.Shop.timeAfter) {
        activityContent += this.$data.Shop.timeBefore.substring(0, 5) + " 以前，或 "
        activityContent += this.$data.Shop.timeAfter.substring(0, 5) + " 以後"
      } else if (this.$data.Shop.timeBefore) {
        activityContent += this.$data.Shop.timeBefore.substring(0, 5) + " 以前"
      } else if (this.$data.Shop.timeAfter) {
        activityContent += this.$data.Shop.timeAfter.substring(0, 5) + " 以後"
      }
      activityContent += "滿 " + this.$data.Shop.activityPrice + " 元，"
      if (this.$data.Shop.payOff) {
        activityContent += "折 " + this.$data.Shop.payOff +  " 元！"
        this.$parent.$data.discountPrice = this.$props.Total - this.$data.Shop.payOff
      } else if (this.$data.Shop.Discount) {
        let strDiscount = this.$data.Shop.Discount.toString()
        if (strDiscount.length == 2) {
          if (strDiscount.substring(1) == "0") strDiscount = strDiscount.substring(0, 1)
        }
        activityContent += "打 " + strDiscount +  " 折！"
        this.$parent.$data.discountPrice = this.$props.Total * this.$data.Shop.Discount / 100
      } else if (this.$data.Shop.Gift) {
        activityContent += "送" + this.$data.Shop.Gift +  "！"
      }
      if (this.$parent.$data.discountPrice > 0) this.$parent.$data.discountPrice = Math.round(this.$parent.$data.discountPrice)
      this.$parent.$data.activityContent = activityContent
    },
  }
}
</script>

<style lang="scss" scoped>
.Order {
  margin: 0px 15px;
  > .col {
    > .Title {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 900;
      color: #87CEFAAA;
      text-shadow: 1px 1px 0 #000000;
      > .discountPrice {
        float: right;
        color: #000000;
        text-shadow: none;
      }
      > .Total {
        float: right;
        color: #000000;
        text-shadow: none;
      }
      > .replaced {
        margin-right: 10px;
        line-height: 27px;
        font-size: 14px;
        color: #FF3333;
        text-decoration: line-through;
      }
    }
    > .orderList {
      > .User {
        margin-bottom: 10px;
        > .Name {
          margin-left: 25px;
          font-size: 16px;
          font-weight: 900;
          color: #5599FF;
          text-shadow: 1px 1px 0 #616161;
        }
        > .Delete {
          float: right;
          margin-right: 25px;
          svg, .fa-solid {
            color: #FFFFFF;
            padding: 5px;
            vertical-align: middle;
            border-radius: 16px;
            background-color: red;
            font-size: 14px;
          }
        }
      }
      > .Product {
        background: #f8f8f8;
        margin-bottom: 10px;
        padding: 20px 20px 15px 20px;
        border-radius: 8px;
        > .Image {
          display: inline;
          float: left;
          height: 80px;
          width: 80px;
          margin-right: 20px;
          position: relative;
          > img {
            border-radius: 8px;
            max-height: 80px;
            max-width: 80px;
            width: auto;
            height: auto;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }
        }
        > .Fas {
          display: inline;
          float: left;
          margin-right: 20px;
          background-color: #5599FF;
          width: 80px;
          height: 80px;
          line-height: 80px;
          border-radius: 8px;
          text-align: center;
          color: #FFFFFF;
          svg {
            vertical-align: middle;
          }
        }
        > .Name {
          padding-top: 15px;
          font-size: 16px;
          font-weight: bold;
          > .editOrderBar {
            float: right;
            svg, .fa-solid {
              color: #FFFFFF;
              padding: 5px;
              vertical-align: middle;
              border-radius: 16px;
            }
            .Edit {
              margin-right: 10px;
              background-color: #5599FF;
              font-size: 14px;
            }
            .Delete {
              background-color: red;
              font-size: 14px;
            }
          }
        }
        > .Content {
          margin-top: 5px;
          padding-bottom: 15px;
          font-size: 15px;
          color: #616161;
        }
        > .noProduct {
          text-decoration: line-through;
          color: red;
        }
      }
      > .IndentProduct {
        margin-left: 25px; 
        margin-right: 25px; 
      }
    }
    .activityBar {
      margin-bottom: 10px;
      padding: 0px 20px;
      height: 116.5px;
      display: flex;
      align-items: center;
      background: #f8f8f8;
      color: #FF3333;
      font-weight: bold;
      text-align: center;
      border-radius: 8px;
    }
  }
}
</style>